import axios, {AxiosError, AxiosResponse} from 'axios';
import {name as appName, version as appVersion} from '../../package.json';
import {inPersistentStore, inTemporaryStore} from '../utils/storage.util';
import {keycloak} from '../auth';

function rejectErrorHandler(error: AxiosError): Promise<AxiosError> {
    return Promise.reject(error);
}

// Defina os interceptores antes de exportar axios
axios.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    (error: AxiosError) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            setTimeout(() => {
                window.location.href = keycloak.createLoginUrl();
            }, 800);
        }
        return rejectErrorHandler(error);
    }
);

axios.interceptors.request.use(
    async (config: any) => {
        const token = inTemporaryStore.getItem('token');

        if (token) {
            if (!config.headers) {
                config.headers = {};
            }

            if (!config.headers['content-type']) {
                config.headers['content-type'] = 'application/json';
            }

            config.headers.Authorization = `Bearer ${token}`;
            config.headers['Access-Control-Allow-Credentials'] = true;
        }

        return config;
    },
    (error: AxiosError) => {
        return rejectErrorHandler(error);
    }
);

export const getEnv = async (property: string): Promise<any> => {
    let data: any = {};
    const cacheKey = `env.json of ${appName} at ${appVersion}`;
    if (inPersistentStore.hasItem(cacheKey)) {
        data = inPersistentStore.getItem(cacheKey);
    } else {
        const resp = await axios.get('/env.json');
        data = resp.data;
        inPersistentStore.setItem(cacheKey, data);
    }
    return data?.[property];
};

export default axios;